<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; My Profile</h5>
      </div>
<div id="mainContent" class="container">
  <div class="pt-4 pb-2" *ngIf="user">
    <div class="col-md-12 ">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th>Full Name</th>
            <th>User Name</th>
            <!-- <th>Login Access</th> -->
            <th>Employee Type</th>
            <th>Status</th>
            <th>Gender</th>
            <th>Official Email</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ user.firstName }} {{ user.middleName }} {{ user.lastName }}
            </td>
            <td>{{ user.email }}</td>
            <!-- <td></td> -->
            <td>{{ user.type }}</td>
            <td *ngIf="user.userOfficialDetails != null">
              <span *ngIf="user.userOfficialDetails.profileStatus == 1"
                >Active</span
              >
              <span *ngIf="user.userOfficialDetails.profileStatus == 0"
                >Closed</span
              >
            </td>
            <td *ngIf="user.userOfficialDetails == null">
              <span>closed</span>
            </td>
            <td *ngIf="user.userOfficialDetails != null">
              {{ user.userPersonalDetails.gender }}
            </td>
            <td *ngIf="user.userOfficialDetails == null"></td>
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
  <br />
  <div id="mainContent" class="container"> 
  <div class="row p-2">
    <div class="col-md-12" >
      <span class="bg-theme-title">My Personal Details</span>
    </div>
  </div>
  <div class="row" *ngIf="user">
    <div class="col-md-7">
      <table class="table table-striped table-bordered table-sm">
        <tbody>
          <tr>
            <th>
              <button
                type="button"
                class="btn btn-xs btn-theme"
                (click)="onEditClick(modalContent)"
              >
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> Edit
              </button>
            </th>
            <td></td>
          </tr>
          <tr>
            <th>Date Of Birth:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.dateOfBirth | date: "dd-MMM-yyyy" }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Qualification:</th>
            <td *ngIf="user.userPersonalDetails != null && user.type=='Article'">
              {{ user.userPersonalDetails.qualification }}
            </td>
            <td *ngIf="user.userPersonalDetails != null && user.type=='Employee'">
              <span
                *ngFor="
                  let qualif of user.userPersonalDetails.userQualifications
                "
              >
                {{ qualif.qualification.name }} ,
              </span>
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Certification:</th>
            <td *ngIf="user.userPersonalDetails != null">
              <span
                *ngFor="
                  let certification of user.userPersonalDetails
                    .userCertifications
                "
              >
                {{ certification.certificationType.name }} ,
              </span>
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Blood Group:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.bloodGroup }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Contact Number Mobile:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.contactMobileNumber }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Official Email:</th>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <th>Personal Email-1:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.personalEmail }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>PAN Number:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.panNumber }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Emergency Contact Number:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.emergencyContactNumber1 }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Emergency Contact Name:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.emergencyContactName1 }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Emergency Contact Name-Relation:</th>
            <td *ngIf="user.userPersonalDetails != null">
              {{ user.userPersonalDetails.emergencyContactRelation1 }}
            </td>
            <td *ngIf="user.userPersonalDetails == null"></td>
          </tr>
          <tr>
            <th>Permanent Address:</th>
            <td *ngIf="user.addresses.length > 0">
              {{ user.addresses[0].address }}
            </td>
            <td *ngIf="user.addresses.length == 0"></td>
          </tr>
          <tr>
            <th>Permanent Address-City:</th>
            <td *ngIf="user.addresses.length > 0">
              {{ user.addresses[0].city ? user.addresses[0].city.name : "" }}
            </td>
            <td *ngIf="user.addresses.length == 0"></td>
          </tr>
          <tr>
            <th>Local Address:</th>
            <td *ngIf="user.addresses.length == 2">
              {{ user.addresses[1].address }}
            </td>
            <td *ngIf="user.addresses.length == 0"></td>
          </tr>
          <tr>
            <th>Local Address-City:</th>
            <td *ngIf="user.addresses.length == 2">
              {{ user.addresses[1].city!=null?user.addresses[1].city.name:"" }}
            </td>
            <td *ngIf="user.addresses.length == 0"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-4" *ngIf="userPhoto">
      <table class="table table-striped table-bordered table-sm">
        <tbody>
          <tr>
            <th>
              <button
                type="button"
                class="btn btn-xs btn-theme"
                (click)="onUploadUserProfileClick(user)"
              >
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> Upload
                User Photo
              </button>
            </th>
          </tr>
          <tr>
            <td  style="background: lightgray; text-align: center;margin:10px;">
              <div style="height: auto; width: 350px">
                <img
                  [src]="userPhoto.url"
                  style="display: block; margin: 2%; width: 96%; height: auto"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Personal Details</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <form [formGroup]="employeeForm">
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Personal Details</h6>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="dateOfBirth" class="mb-0"
                  >Date Of Birth <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    name="dateOfBirth"
                    formControlName="dateOfBirth"
                    ngbDatepicker
                    #dateOfBirth="ngbDatepicker"
                    [class.is-invalid]="
                      employeeFormErrors.dateOfBirth && employeeFormSubmitted
                    "
                    matTooltip="{{ employeeFormErrors.dateOfBirth }}"
                    matTooltipPosition="above"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar"
                      (click)="dateOfBirth.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="qualification" class="mb-0"
                  >Qualification <span class="text-danger">*</span></label
                >
                <input
                  id="qualification"
                  name="qualification"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.qualification }}"
                  matTooltipPosition="above"
                  formControlName="qualification"
                  [class.is-invalid]="
                    employeeFormErrors.qualification && employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="bloodGroup" class="mb-0"
                  >Blood Group <span class="text-danger">*</span></label
                >
                <input
                  id="bloodGroup"
                  name="bloodGroup"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.bloodGroup }}"
                  matTooltipPosition="above"
                  formControlName="bloodGroup"
                  [class.is-invalid]="
                    employeeFormErrors.bloodGroup && employeeFormSubmitted
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="panNumber" class="mb-0"
                  >PAN Number <span class="text-danger">*</span></label
                >
                <input
                  id="panNumber"
                  name="panNumber"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.panNumber }}"
                  matTooltipPosition="above"
                  formControlName="panNumber"
                  [class.is-invalid]="
                    employeeFormErrors.panNumber && employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="aadharNumber" class="mb-0"
                  >Aadhar Number <span class="text-danger">*</span></label
                >
                <input
                  id="aadharNumber"
                  name="aadharNumber"
                  type="number"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.aadharNumber }}"
                  matTooltipPosition="above"
                  formControlName="aadharNumber"
                  [class.is-invalid]="
                    employeeFormErrors.aadharNumber && employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <mat-form-field
                  appearance="legacy"
                  style="width: 100%"
                  [class.mat-form-field-invalid]="
                    employeeFormErrors.certificationType &&
                    employeeFormSubmitted
                  "
                >
                  <mat-label>Certification :</mat-label>
                  <mat-select
                    formControlName="certificationType"
                    multiple
                    [compareWith]="compareItems"
                  >
                    <mat-option
                      #item
                      *ngFor="let certification of certificationList"
                      [value]="certification"
                      (click)="checkSelection()"
                    >
                      {{ certification.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-4" *ngIf="showDescription">
              <div class="form-group mb-0">
                <label for="description" class="mb-0"
                  >Certification <span class="text-danger">*</span></label
                >
                <input
                  id="description"
                  name="description"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.description }}"
                  matTooltipPosition="above"
                  formControlName="description"
                  [class.is-invalid]="
                    employeeFormErrors.description && employeeFormSubmitted
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Contact Details</h6>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="personalEmail" class="mb-0"
                  >Personal Email ID <span class="text-danger">*</span></label
                >
                <input
                  id="personalEmail"
                  name="personalEmail"
                  type="email"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.personalEmail }}"
                  matTooltipPosition="above"
                  formControlName="personalEmail"
                  [class.is-invalid]="
                    employeeFormErrors.personalEmail && employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="officalMobileNumber" class="mb-0"
                  >Official Mobile Number
                  <span class="text-danger">*</span></label
                >
                <input
                  id="officalMobileNumber"
                  name="officalMobileNumber"
                  type="number"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.officalMobileNumber }}"
                  matTooltipPosition="above"
                  formControlName="officalMobileNumber"
                  [class.is-invalid]="
                    employeeFormErrors.officalMobileNumber &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="contactMobileNumber" class="mb-0"
                  >Contact Number Mobile
                  <span class="text-danger">*</span></label
                >
                <input
                  id="contactMobileNumber"
                  name="contactMobileNumber"
                  type="number"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.contactMobileNumber }}"
                  matTooltipPosition="above"
                  formControlName="contactMobileNumber"
                  [class.is-invalid]="
                    employeeFormErrors.contactMobileNumber &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Emergency Contact Number 1
                  <span class="text-danger">*</span></label
                >
                <input
                  id="emergencyContactNumber1"
                  name="emergencyContactNumber1"
                  type="number"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.emergencyContactNumber1 }}"
                  matTooltipPosition="above"
                  formControlName="emergencyContactNumber1"
                  [class.is-invalid]="
                    employeeFormErrors.emergencyContactNumber1 &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Emergency Contact 1 Name
                  <span class="text-danger">*</span></label
                >
                <input
                  id="emergencyContactName1"
                  name="emergencyContactName1"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.emergencyContactName1 }}"
                  matTooltipPosition="above"
                  formControlName="emergencyContactName1"
                  [class.is-invalid]="
                    employeeFormErrors.emergencyContactName1 &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Emergency Contact 1 Relation
                  <span class="text-danger">*</span></label
                >
                <input
                  id="emergencyContactRelation1"
                  name="emergencyContactRelation1"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{
                    employeeFormErrors.emergencyContactRelation1
                  }}"
                  matTooltipPosition="above"
                  formControlName="emergencyContactRelation1"
                  [class.is-invalid]="
                    employeeFormErrors.emergencyContactRelation1 &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Contact Details</h6>
        </div>
        <div class="col-md-12" formGroupName="permanentAddress">
          <div class="row mb-1">
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Permanent Address <span class="text-danger">*</span></label
                >
                <input
                  id="permanentAddress"
                  name="permanentAddress"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.address }}"
                  matTooltipPosition="above"
                  formControlName="address"
                  [class.is-invalid]="
                    employeeFormErrors.address &&
                    employeeForm.controls.permanentAddress.controls.address
                      .invalid &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Permanent Street Name
                  <span class="text-danger">*</span></label
                >
                <input
                  id="permanentStreetName"
                  name="permanentStreetName"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.address }}"
                  matTooltipPosition="above"
                  formControlName="streetName"
                  [class.is-invalid]="
                    employeeFormErrors.address &&
                    employeeForm.controls.permanentAddress.controls.address
                      .invalid &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Permanent Address State
                  <span class="text-danger">*</span></label
                >
                <select
                  class="form-control form-control-xs"
                  id="permanentState"
                  name="permanentState"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="state"
                  (change)="
                    loadPermanantCities(
                      employeeForm.controls.permanentAddress.get('state').value
                    )
                  "
                  [class.is-invalid]="
                    employeeFormErrors.state &&
                    employeeForm.controls.permanentAddress.controls.state
                      .invalid &&
                    employeeFormSubmitted
                  "
                  matTooltip="{{ employeeFormErrors.state }}"
                  matTooltipPosition="above"
                >
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let state of stateList" [ngValue]="state">
                    {{ state.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Permanent Address City
                  <span class="text-danger">*</span></label
                >
                <select
                  *ngIf="modalStatus == 'edit' && showPermanentCity"
                  class="form-control form-control-xs"
                  id="permanentCity"
                  name="permanentCity"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="city"
                  (change)="
                    loadPermanantPostcode(
                      employeeForm.controls.permanentAddress.get('city').value
                    )
                  "
                  [class.is-invalid]="
                    employeeFormErrors.city &&
                    employeeForm.controls.permanentAddress.controls.city
                      .invalid &&
                    employeeFormSubmitted
                  "
                  matTooltip="{{ employeeFormErrors.city }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option
                    *ngFor="let city of permanentCityList"
                    [ngValue]="city"
                  >
                    {{ city.name }}
                  </option>
                </select>

                <div
                  *ngIf="modalStatus == 'edit' && !showPermanentCity"
                  (click)="enablePermanentCity()"
                  matTooltip="'Click To Change'"
                  matTooltipPosition="above"
                  style="cursor: pointer"
                >
                  <span *ngIf="this.employeeForm.value.permanentAddress.city">{{
                    this.employeeForm.value.permanentAddress.city.name
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Permanent Address Pincode
                  <span class="text-danger">*</span></label
                >

                <select
                  *ngIf="modalStatus == 'edit' && showPermanentPostCode"
                  class="form-control form-control-xs"
                  id="permanentPostalCode"
                  name="permanentPostalCode"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="postalCode"
                  [class.is-invalid]="
                    employeeFormErrors.postalCode &&
                    employeeForm.controls.permanentAddress.controls.postalCode
                      .invalid &&
                    employeeFormSubmitted
                  "
                  matTooltip="{{ employeeFormErrors.postalCode }}"
                  matTooltipPosition="above"
                >
                  <option [ngValue]="null">Select</option>
                  <option
                    *ngFor="let postCode of permanentPostcodeList"
                    [ngValue]="postCode"
                  >
                    {{ postCode.name }}
                  </option>
                </select>

                <div
                  *ngIf="modalStatus == 'edit' && !showPermanentPostCode"
                  (click)="enablePermanentPostCode()"
                  matTooltip="'Click To Change'"
                  matTooltipPosition="above"
                  style="cursor: pointer"
                >
                  <span
                    *ngIf="this.employeeForm.value.permanentAddress.postalCode"
                    >{{
                      this.employeeForm.value.permanentAddress.postalCode.name
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="" class="mb-0"
                  >Country <span class="text-danger">*</span></label
                >
                <input
                  id="country1"
                  name="country"
                  type="text"
                  class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.country }}"
                  matTooltipPosition="above"
                  formControlName="country"
                  [class.is-invalid]="
                    employeeFormErrors.country &&
                    employeeForm.controls.permanentAddress.controls.country
                      .invalid &&
                    employeeFormSubmitted
                  "
                />
              </div>
            </div>
            <div class="col-sm-4"></div>
            <div class="col-sm-4"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button
          id="updatePersonalDetailsBtn"
          name="updatePersonalDetailsBtn"
          type="button"
          *ngIf="modalStatus == 'edit'"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onUpdateClick()"
        >
          Update
        </button>
      </div>
      <div class="col-sm-3">
        <button
          id="closePersonalDetailsBtn"
          name="closePersonalDetailsBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modal.dismiss('Cross click')"
        >
          Close
        </button>
      </div>
     
    </div>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #userProfileModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">User Photo</h5>
  </div>
  <div class="modal-body">
    <div class="row col-md-12">
      <div class="col-sm-4">
        <label>Select User Photo :</label>
      </div>
      <div class="col-sm-8">
        <input
          type="file"
          (change)="fileChange($event)"
          placeholder="Upload file"
          accept=".jpg,.jpeg,.png"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button
          id="updatePhotoBtn"
          name="updatePhotoBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onUploadClick()"
        >
          Upload
        </button>
      </div>
      <div class="col-sm-3">
        <button
          id="closeAssignmentBtn"
          name="closeAssignmentBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modal.dismiss('Cross click')"
        >
          Close
        </button>
      </div>

    </div>
  </div>
</ng-template>
